import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/enhanced-button";
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle, LogIn } from "lucide-react";

const TokenExpired = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-secondary flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Card className="border-0 shadow-xl bg-card/95 backdrop-blur-sm">
          <CardContent className="p-8 text-center">
            <div className="mb-8">
              <div className="w-16 h-16 mx-auto mb-4 bg-destructive/10 rounded-xl flex items-center justify-center">
                <AlertCircle className="w-10 h-10 text-destructive" />
              </div>
              <h1 className="text-2xl font-bold text-foreground mb-2">
                Session Expired
              </h1>
              <p className="text-muted-foreground mb-4">
                Your authentication token has expired. Please sign in again to continue.
              </p>
              <p className="text-sm text-muted-foreground">
                This helps keep your account secure by requiring periodic re-authentication.
              </p>
            </div>

            <Button
              size="lg"
              className="w-full"
              onClick={() => navigate("/login", { replace: true })}
            >
              <LogIn className="w-5 h-5 mr-2" />
              Sign in
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TokenExpired;
